import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  EyeTwoTone, UserOutlined, GlobalOutlined, SafetyOutlined, FieldTimeOutlined
} from '@ant-design/icons';
import { Drawer, Descriptions } from 'antd';
import { getAllUsers } from '../../../redux/User/actions';
import { fetchCountries } from '../../../redux/Country/actions';
import ShowMachineUserDetails from './ShowMachineUserDetails';

const ShowMachine = ({ item }) => {
  const [modelVisible, setModelVisible] = useState(false);
  const dispatch = useDispatch();

  // Fetch data from Redux store
  const { users } = useSelector(state => state.users) || { users: [] };
  const { countries } = useSelector(state => state.countries) || { countries: [] };

  useEffect(() => {
    dispatch(getAllUsers());
    dispatch(fetchCountries());
  }, [dispatch]);

  // Find machine-specific data
  const machineUser = users.find(user => user._id === item.user) || {};
  const machineCountry = countries.find(country => country._id === item.country) || {};

  const showModal = () => {
    setModelVisible(true);
  };

  const hideModalCancel = () => {
    setModelVisible(false);
  };

  return (
    <>
      <EyeTwoTone key="view" onClick={showModal} />
      <Drawer
        title={item.machinename ? `Details for ${item.machinename}` : "Machine Details"}
        visible={modelVisible}
        closable={true}
        placement={window.innerWidth <= 500 ? 'top' : 'right'}
        onClose={hideModalCancel}
        okText="OK"
        cancelText="Close"
        width={window.innerWidth <= 500 ? '100%' : 600}
      >
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Machine ID">
            <SafetyOutlined style={{ marginRight: 8 }} />
            {item.machineid || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Machine Name">
            <UserOutlined style={{ marginRight: 8 }} />
            {item.machinename || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="User">
            {machineUser ? (
                    <ShowMachineUserDetails userId={item.user} />
                ) : "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Country">
            <GlobalOutlined style={{ marginRight: 8 }} />
            {machineCountry ? machineCountry.name || "N/A" : "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Is Linked PC">
            <span style={{ color: item.islinkedPC ? "blue" : "red" }}>
              {item.islinkedPC ? "Yes" : "No"}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label="ID PC">
            {item.idpc || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Key PC">
            {item.keypc || "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Is Active">
            <span style={{ color: item.isActive ? "blue" : "red" }}>
              {item.isActive ? "Yes" : "No"}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label="Is Deleted">
            {item.isDeleted ? "Yes" : "No"}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {item.createdAt ? new Date(item.createdAt).toLocaleString() : "N/A"}
          </Descriptions.Item>
          <Descriptions.Item label="Updated At">
            {item.updatedAt ? new Date(item.updatedAt).toLocaleString() : "N/A"}
          </Descriptions.Item>
        </Descriptions>
      </Drawer>
    </>
  );
};

export default ShowMachine;
